import type { ImagesService } from '@/engine/app/modules/images/Images.service.ts';
import type { IImageScrollStrategy } from '@/engine/app/modules/images/interfaces.ts';
import type { SliceType } from '@/engine/app/modules/images/interfaces.ts';

import * as THREE from 'three';

export class ImageRotationScrollStrategy implements IImageScrollStrategy {
  private _imagesService: ImagesService;

  public constructor(imagesService: ImagesService) {
    this._imagesService = imagesService;
  }

  public handleScroll(delta: number, sliceType: SliceType): void {
    const radDelta = THREE.MathUtils.degToRad(delta);
    const slicePositionInfo = this._imagesService.getSlicePositionInfo(sliceType);

    const complimentaryImageSliceToMpr = this._imagesService.getPolylineInfo()?.slice;
    if (!complimentaryImageSliceToMpr) throw new Error('No centerline selected');

    const currentAngleValue = slicePositionInfo?.mprSliceRotations.get(complimentaryImageSliceToMpr) ?? 0;
    this._imagesService.setImageSliceRotation(sliceType, complimentaryImageSliceToMpr, currentAngleValue + radDelta);
  }
}
